/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Proof_NoteInputs */

const en_cap_proof_note = /** @type {(inputs: Cap_Proof_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo’s own production systems, written up as case studies.`)
};

const lv_cap_proof_note = /** @type {(inputs: Cap_Proof_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo pašu darba sistēmas, aprakstītas kā gadījumu izpētes.`)
};

/**
* | output |
* | --- |
* | "Lindevo’s own production systems, written up as case studies." |
*
* @param {Cap_Proof_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_proof_note = /** @type {((inputs?: Cap_Proof_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Proof_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_proof_note(inputs)
	return en_cap_proof_note(inputs)
});